import ACTIONS from "../../constatnts";

export const setApiKey = (payload) => ({
  type: ACTIONS.SET_APIKEY,
  payload,
});
